import { useHistory } from 'react-router-dom'
import { BaseUXComponentActions } from 'src/componentsV2/CoreUX/UXComponentRenderer/uxComponent.types'
import {
  Action,
  ActionType,
  ActionExecutor
} from 'src/componentsV2/CoreUX/actions/baseAction.types'
import { useOverlayManager } from 'src/hooks/useOverlayManager'
import { TrackActionExecutor } from 'src/componentsV2/CoreUX/actions/trackAction/trackAction'
import { NavigationActionExecutor } from 'src/componentsV2/CoreUX/actions/navigationAction/navigationAction'
import { OverlayActionExecutor } from 'src/componentsV2/CoreUX/actions/overlayAction/overlayAction'

interface UseActionsReturn {
  onClick: () => void
  onView: () => void
  onScroll: () => void
}

const actionExecutorByType: Record<ActionType, ActionExecutor> = {
  [ActionType.Navigation]: new NavigationActionExecutor(),
  [ActionType.Track]: new TrackActionExecutor(),
  [ActionType.Overlay]: new OverlayActionExecutor()
}

/**
 * A hook that processes component actions and returns callback functions
 * for different event types (onClick, onView, onScroll)
 */
export const useActions = (
  actions?: Partial<BaseUXComponentActions>
): UseActionsReturn => {
  const history = useHistory()
  const { showOverlay } = useOverlayManager()

  const processActions = (actionsList: Action<ActionType>[] = []) => {
    actionsList.forEach(action => {
      actionExecutorByType[action.type].execute(action, {
        history,
        showOverlay
      })
    })
  }

  const onClick = actions?.onClick?.length
    ? () => processActions(actions.onClick)
    : () => {}

  const onView = actions?.onView?.length
    ? () => processActions(actions.onView)
    : () => {}

  const onScroll = actions?.onScroll?.length
    ? () => processActions(actions.onScroll)
    : () => {}

  return {
    onClick,
    onView,
    onScroll
  }
}
